<script setup lang="ts">
import { getBadgeFromScore } from '@openesg/widget/src/generate'
import type { WidgetStyles } from '@openesg/widget/src/types'

export interface Props {
  isProduct?: boolean
  isVerified?: boolean
  size?: WidgetStyles
  score: number | string
  isFullBadge?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  isProduct: false,
  isVerified: false,
  size: 'lg',
  isFullBadge: false,
})

const badgeSrc = computed(() => {
  const badgeMetal = getBadgeFromScore(props.score as number)
  const badgeType = props.isFullBadge ? 'branded' : 'basic'
  const scoreType = props.isProduct ? 'p' : 'c'
  const scoreState = props.isVerified ? 'verified' : 'unverified'

  if (badgeMetal) {
    return `/img/badges/${badgeType}/${scoreType}/${scoreState}/${badgeMetal}/${props.size}.svg`
  }
})
</script>
<template lang="pug">
div(class="relative aspect-[9/8] shrink-0 grow")
  img(
    v-if="badgeSrc"
    :src="badgeSrc"
    class="w-full h-full object-contain object-center"
  )
  div(
    v-else
    class="w-full h-full shadow-line rounded-tr-[12.5%] flex items-center justify-center bg-gray-200/50"
  )
    span(class="text-xs text-gray-400") No badge earned
</template>
